import { ReactNode } from 'react'
import '../../editor/editor-view.css'

export function CommentContainer({
  children,
  className,
}: {
  className?: string
  children: ReactNode
}) {
  return (
    <section className={'comment-view' + (className ? ' ' + className : '')}>
      {children}
    </section>
  )
}
